<template>
  <div class="aboveallhtml">
    <div class="aboveallmid">
      <div class="aboveallhead">
        <transition name="flip-list" mode="out-in">
          <div
            :style="{
              background: 'url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=26) no-repeat center',
            }"
            :src="imagesrc[imgindex]"
            :key="imagesrc[imgindex]"
            class="imgsrc"
            id="imgsrc"
            ref="imgsrc"
          ></div>
        </transition>
        <!-- <img src="../../assets/images/banner.jpg" alt=""> -->
      </div>
      <div class="aboveallyellow">
        <div class="yellowtext">
          <div class="yellowleft">
            <p
              style="
                color: white;
                font-size: 20px;
                text-align: right;
                line-height: 30px;
                font-weight: bold;
                margin-top: 35px;
                margin-right: 30px;
                letter-spacing: 1px;
              "
            >
              睿期
            </p>
            <p
              style="
                color: white;
                font-size: 20px;
                text-align: right;
                line-height: 30px;
                font-weight: bold;
                margin-right: 30px;
                letter-spacing: 1px;
              "
            >
              大户室期货软件
            </p>
          </div>
          <div class="yellowright">
            <!-- <p class="righttext">
              文华财经旗下的一款收费的高端行情交易软件，针对机构和专业投资者，提供一机多屏、F9商品深度资料、指标预警、趋势线预警，以及可以选配的多账号一带多下单、套利交易、国内五档行情数据、外盘行情数据...
            </p> -->
            <ResTxt class="righttext" id="7a18cbda86053" />
            <div class="aquestion">
              <img src="../../assets/images/wenh.png" />
              <div
                style="
                  letter-spacing: 1px;
                  position: relative;
                  bottom: 4px;
                  display: inline-block;
                  margin-left: 5px;
                "
              >
                <a
                  style="color: #304560; font-size: 12px"
                  target="_blank"
                  href="https://pay.wenhua.com.cn/#/question"
                >
                  购买相关常见问题</a
                >
              </div>
            </div>
            <div class="aquestion" style="margin-left: 68px; font-size: 12px">
              <img src="../../assets/images/PT-01.png" />
              <div
                style="
                  letter-spacing: 1px;
                  position: relative;
                  bottom: 4px;
                  display: inline-block;
                  margin-left: 3px;
                "
              >
                wh7配套系统－文华TMS交易管理系统
                <a
                  style="color: #304560; margin-left: 2px"
                  target="_blank"
                  href="https://tms.wenhua.com.cn/#/home"
                >
                  去进一步了解</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="aboveallbody">
        <div class="bodymid">
          <div class="bdmidleft">
            <img src="../../assets/images/liyou.png" alt="" style="position:absolute;top:-20px;right:10px">
            <div class="flex2" style="margin-top:83px">
              <div class="flex1">
                <router-link to='/proc/productcenter2/one'>
                  <div class="back1">
                    <div class="ref-wrap">
                      <div class="title1">多账号下单</div>
                    </div>
                  </div>
                </router-link>
                 <router-link to='/proc/productcenteryc/ycpd' style="margin-top:10px">
                  <div class="back3">
                    <div class="ref-wrap">
                       <div class="title1">移仓交易</div>
                       <div class="text1" style="width:190px">移仓价差统计、移仓量图表、多账号移仓</div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="flex1">
                <router-link to='/proc/productcentertl/zypd'>
                  <div class="back2">
                    <div class="ref-wrap">
                       <div class="title1">套利交易</div>
                       <div class="text1" style="width:190px">套利价差k线图、套利下单任务、多账号套利</div>
                    </div>
                  </div>
                </router-link>
                 <router-link to='/proc/productcenterjg/wgjy' style="margin-top:10px">
                  <div class="back4">
                    <div class="ref-wrap">
                      <div class="title1">网格策略交易</div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="flex2">
              <router-link to='/proc/productcenterjg/rwglq' style="margin-right:10px">
                  <div class="back5">
                    <div class="ref-wrap">
                      <div class="title1">下单任务管理器</div>
                    </div>
                  </div>
                </router-link>
                 <router-link to='/proc/productcenterjg/qqjy'>
                  <div class="back6">
                    <div class="ref-wrap">
                      <div class="title1">期权组合策略</div>
                    </div>
                  </div>
                </router-link>
            </div>
          </div>
          <div class="bdmidright" style="margin-top:8px">
            <div class="flex2">
                <router-link to='/proc/productcenterhq/yjdp'>
                  <div class="back7" style="bottom: -5px;">
                    <div class="ref-wrap">
                      <div class="title2">一机多屏</div>
                    </div>
                  </div>
                </router-link>
                <router-link to='/proc/productcenterhq/qsxyj'>
                  <div class="back8" style="bottom: -5px;left: 10px;">
                    <div class="ref-wrap">
                      <div class="title2">云端功能</div>
                      <div class="text2" style="width:190px">趋势线预警、公式预警、公式选股</div>
                    </div>
                  </div>
                </router-link>
            </div>
            <div class="flex2">
              <div class="flex1">
                <router-link to='/buy/wp'>
                  <div class="back9">
                    <div class="ref-wrap">
                      <div class="title2">五档行情数据</div>
                    </div>
                  </div>
                </router-link>
                <router-link to='/proc/productcenterhq/xhsj' style="margin-top:10px">
                  <div class="back11">
                    <div class="ref-wrap">
                      <div class="title2">K线图叠加现货数据</div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="flex1">
                <router-link to='/proc/productcenterhq/kzfx'>
                  <div class="back10">
                    <div class="ref-wrap">
                      <div class="title2">扩展分析</div>
                      <div class="text2" style="width:150px">回归分析、波动率分析、季节性分析、期货横截面、期现链</div>
                    </div>
                  </div>
                </router-link>
                <router-link to='/buy/wp' style="margin-top:6px">
                  <div class="back12">
                    <div class="ref-wrap">
                      <div class="title2">外盘行情数据</div>
                    </div>
                  </div>
                </router-link>
                <div class="back13" style="margin-top:8px">
                  <div class="ref-wrap">
                    <div style="text-align:center;font-size:28px;;line-height:33px;color: rgb(102, 71, 18);"> ... ... </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import ResTxt from "@/ResData/ResTxt";
export default {
  components: {
    wh7footer,
    ResTxt,
  },
  data() {
    return {
      yjdp: false,

      activeName: "first",
      imgindex: 0,
      imagesrc: [require("../../assets/images/banner.jpg")],
      test: {},
      timeset: null,
    };
  },
  methods: {
    // wh7lunbo(){
    //   while(this.index<this.imagesrc.length){
    //   setInterval(function(){ this.index=this.index+1 }, 2000);

    //   console.log(this.imagesrc[this.index])
    //   }
    //   this.index=0
    //    this.wh7lunbo()
    // },
    wh7lunbo() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex);
      }, 2000);
    },
    gotoPage(index) {
      this.imgindex = index;
    },
  },
  computed: {
    nextIndex() {
      if (this.imgindex == this.imagesrc.length - 1) {
        return 0;
      } else {
        return this.imgindex + 1;
      } //首页最上方图片轮播
    },
  },
  mounted() {
    this.wh7lunbo();

    var ua = navigator.userAgent.toLowerCase();
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
      ua.match(/iphone os/i) == "iphone os" ||
      ua.match(/ipad/i) == "ipad" ||
      ua.match(/android/i) == "android" ||
      ua.match(/midp/i) == "midp" ||
      ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4" ||
      ua.match(/ucweb/i) == "ucweb" ||
      ua.match(/windows ce/i) == "windows ce" ||
      ua.match(/windows mobile/i) == "windows mobile"
    ) {
      this.$refs.imgsrc.style.width = 100 + "%";
      this.$refs.imgsrc.style.margin = 0;
    }
    //  document.getElementById("imgsrc").css("background","url("+this.imagesrc[this.imgindex]+")")
  },
};
</script>

<style>
td {
  height: 35px;
  border: 1px solid #cdcdcd;
  line-height: 35px;
  vertical-align: middle;
  font-size: 14px;
  padding-left: 40px;
  letter-spacing: 1px;
}
.aboveallhtml {
  z-index: 30;
  margin: 0 auto;
  min-width: 1400px;
  width: 100%;
  padding-top: 22px;
}
.aboveallhead {
  text-align: center;
  height: 389px;
  min-width: 1400px;
  width: 100%;
  margin: 0 auto;
}
.imgsrc {
  background: url("../../assets/images/banner.jpg") no-repeat center;
  height: 100%;
  min-width: 1400px;
  /* width:106%; 
  margin-left:-3%; */
  /* image-rendering: pixelated; */
}
.aboveallyellow {
  background: url("../../assets/images/about.jpg") no-repeat center;
  height: 126px;
  background-size: auto 100%;
  min-width: 1400px;
  width: 100%;
  margin: 0 auto;
}
.aboveallbody {
  background: url("../../assets/images/ly-bg.jpg") no-repeat center;
  background-size: auto 100%;
  width: 1400px;
  width: 100%;
  margin: 0 auto;
}
.yellowright {
  float: right;
  width: 870px;
  height: 129px;
}
.yellowleft {
  float: left;

  width: 330px;
  height: 129px;
}
.yellowtext {
  width: 1200px;
  margin: 0 auto;
  height: 129px;
}
.righttext {
  width: 807px;
  font-size: 14px;
  margin-left: 50px;
  margin-top: 37px;
  line-height: 20px;
  margin-right: 0px;
  letter-spacing: 1px;
}
.aquestion {
  float: left;
  margin-left: 50px;
  margin-top: 15px;
}

.aboveallmid {
  min-width: 1400px;
  max-width: 100%;
}
.bodymid{
  width: 1320px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 80px;
  padding-bottom: 90px;
}
.bdmidleft{
  margin-right: 20px;
  position: relative;
}
.flex1{
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.flex2{
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}
.ref-wrap{
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  transition: all .4s;
}
.back1{
  position:relative;
  width:316px;
  height:218px
}
.back1 .ref-wrap{
  background: url(../../assets/images/mp_L_01.png) no-repeat center;
  background-size: contain;
}
.back1 .ref-wrap:hover{
  z-index: 40;
  bottom: -2.5%;
  right: -2.5%;
}
.back2{
  position:relative;
  width:316px;
  height:198px
}
.back2 .ref-wrap{
  background: url(../../assets/images/mp_L_02.png) no-repeat center;
  background-size: contain;
}
.back2 .ref-wrap:hover{
  z-index: 40;
  bottom: -2.5%;
  left: -2.5%;
}
.back3{
  position:relative;
  width:316px;
  height:178px
}
.back3 .ref-wrap{
  background: url(../../assets/images/mp_L_03.png) no-repeat center;
  background-size: contain;
}
.back3 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  right: -2.5%;
}
.back4{
  position:relative;
  width:316px;
  height:198px
}
.back4 .ref-wrap{
  background: url(../../assets/images/mp_L_04.png) no-repeat center;
  background-size: contain;
}
.back4 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  left: -2.5%;
}
.back5{
  position:relative;
  width:346px;
  height:198px
}
.back5 .ref-wrap{
  background: url(../../assets/images/mp_L_05.png) no-repeat center;
  background-size: contain;
}
.back5 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  right: -2.5%;
}
.back6{
  position:relative;
  width:286px;
  height:198px
}
.back6 .ref-wrap{
  background: url(../../assets/images/mp_L_06.png) no-repeat center;
  background-size: contain;
}
.back6 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  left: -2.5%;
}


.back7{
  position:relative;
  width:286px;
  height:198px
}
.back7 .ref-wrap{
  background: url(../../assets/images/mp_R_01.png) no-repeat center;
  background-size: contain;
}
.back7 .ref-wrap:hover{
  z-index: 40;
  bottom: -2.5%;
  right: -2.5%;
}
.back8{
  position:relative;
  width:360px;
  height:204px
}
.back8 .ref-wrap{
  background: url(../../assets/images/mp_R_02.png) no-repeat center;
  background-size: contain;
}
.back8 .ref-wrap:hover{
  z-index: 40;
  bottom: -2.5%;
  left: -2.5%;
}

.back9{
  position:relative;
  width:316px;
  height:228px
}
.back9 .ref-wrap{
  background: url(../../assets/images/mp_R_03.png) no-repeat center;
  background-size: contain;
}
.back9 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  right: -2.5%;
}
.back10{
  position:relative;
  width:317px;
  height:202px
}
.back10 .ref-wrap{
  background: url(../../assets/images/mp_R_04.png) no-repeat center;
  background-size: contain;
}
.back10 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  left: -2.5%;
}
.back11{
  position:relative;
  width:316px;
  height:228px
}
.back11 .ref-wrap{
  background: url(../../assets/images/mp_R_05.png) no-repeat center;
  background-size: contain;
}
.back11 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  right: -2.5%;
}
.back12{
  position:relative;
  width:316px;
  height:198px
}
.back12 .ref-wrap{
  background: url(../../assets/images/mp_R_06.png) no-repeat center;
  background-size: contain;
}
.back12 .ref-wrap:hover{
  z-index: 40;
  top: -2.5%;
  left: -2.5%;
}
.back13{
  position:relative;
  width:316px;
  height:52px
}
.back13 .ref-wrap{
  background: url(../../assets/images/mp_R_07.png) no-repeat center;
  background-size: contain;
}
.title1{
  font-size: 18px;
  color: #2f4b62;
  margin-left: 25px;
  margin-top: 25px;
}
.title2{
  font-size: 18px;
  color: rgb(102, 71, 18);
  margin-left: 25px;
  margin-top: 25px;
}
.text1{
  color: #2f4b62;
  font-size: 14px;
  margin-left: 25px;
  margin-top: 15px;
  line-height: 22px;
}
.text2{
  font-size: 14px;
  color: rgb(102, 71, 18);
  margin-left: 25px;
  margin-top: 15px;
  line-height: 22px;
}

</style>